import { jsx as _jsx } from "react/jsx-runtime";
function CaretLeft({ className, size = 24 }) {
    return (_jsx("svg", { className: className, height: size, width: size, fill: "currentColor", viewBox: "0 0 24 24", children: _jsx("path", { fillRule: "evenodd", d: "M15.08 8.667L11.749 12l3.333 3.333-1.414 1.414L8.919 12l4.748-4.748 1.414 1.415z", clipRule: "evenodd" }) }));
}
export default CaretLeft;
